import React from "react";
import { Check, X, Award } from "lucide-react";

const comparisons = [
  {
    feature: "Legal Document Stamping & BBMP Liaison",
    housyHunt: "Official e-stamping, certified lawyers & end-to-end follow up",
    localBroker: "Manual photocopies, unverified clauses, sub-registrar delays",
  },
  {
    feature: "Tenant Verification & Screening",
    housyHunt: "Police verification, Aadhaar check, credit score & employer check",
    localBroker: "Basic casual conversation, no documented background proof",
  },
  {
    feature: "Pricing & Quotation Transparency",
    housyHunt: "100% upfront fixed pricing, no hidden costs or sudden surcharges",
    localBroker: "Arbitrary commissions, surprise fees, vendor kickbacks",
  },
  {
    feature: "Service Guarantee & Warranties",
    housyHunt: "1-Year warranty on painting, guaranteed rental dates, SLA contracts",
    localBroker: "Zero warranty, unavailable once payment is collected",
  },
  {
    feature: "Dedicated Relationship Manager",
    housyHunt: "Single point of contact on WhatsApp & Phone with 24/7 support",
    localBroker: "Multiple third-party technicians, disorganized communications",
  },
];

const ServicesComparison = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-12 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-50 text-red-600 border border-red-100 text-xs font-bold uppercase tracking-wider mb-4">
            The HousyHunt Advantage
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-gray-900 tracking-tight">
            Why Discerning Owners <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-rose-600">
              Choose HousyHunt
            </span>
          </h2>
          <p className="mt-4 text-gray-600 text-base sm:text-lg">
            See how our institutional-grade property standards outperform fragmented local contractors.
          </p>
        </div>

        <div className="bg-white rounded-3xl border border-gray-200 shadow-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50/70">
                  <th className="py-5 px-6 sm:px-8 text-sm sm:text-base font-bold text-gray-900 w-1/3">
                    Deliverable / Feature
                  </th>
                  <th className="py-5 px-6 sm:px-8 text-sm sm:text-base font-extrabold text-red-600 bg-red-50/50 w-1/3 border-x border-red-100">
                    <div className="flex items-center gap-2">
                      <Award className="w-5 h-5 text-red-600" />
                      <span>HousyHunt Standard</span>
                    </div>
                  </th>
                  <th className="py-5 px-6 sm:px-8 text-sm sm:text-base font-bold text-gray-500 w-1/3">
                    Unorganized Local Brokers / DIY
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 text-sm">
                {comparisons.map((row, i) => (
                  <tr key={i} className="hover:bg-gray-50/50 transition-colors">
                    <td className="py-5 px-6 sm:px-8 font-bold text-gray-900">
                      {row.feature}
                    </td>
                    <td className="py-5 px-6 sm:px-8 bg-red-50/20 border-x border-red-100 text-gray-800 font-medium">
                      <div className="flex items-start gap-3">
                        <div className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0 mt-0.5">
                          <Check className="w-3.5 h-3.5 stroke-[3]" />
                        </div>
                        <span>{row.housyHunt}</span>
                      </div>
                    </td>
                    <td className="py-5 px-6 sm:px-8 text-gray-500">
                      <div className="flex items-start gap-3">
                        <div className="w-5 h-5 rounded-full bg-red-100 text-red-500 flex items-center justify-center shrink-0 mt-0.5">
                          <X className="w-3.5 h-3.5 stroke-[3]" />
                        </div>
                        <span>{row.localBroker}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesComparison;
